import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Box, Button, Card, CardActions, CardContent, Container, Paper, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';

export default function LandingPage() {
    const navigation = useNavigate();

    return (
        <div>
            <Header />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '100vh'
                }}
            >
                <Container>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Paper onClick={()=>{navigation('/register-grievance');}} elevation={3} className="boxPaper" sx={{
                                transition: 'linear 0.6s',
                                color: 'primary.main',
                                '&:hover': {
                                    backgroundColor: 'primary.main',
                                    color: '#fff',
                                    // boxShadow: '0px 0px 8px 3px rgba(0,0,0,0.5)',
                                },
                                padding: 10,
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                color: '#005696',
                                letterSpacing: 1,
                                cursor: 'pointer',
                            }}>
                                Register Your Grievance (CGRO/RGRO)
                            </Paper>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Paper onClick={()=>{navigation('/grievance-status');}} elevation={3} className="boxPaper" sx={{
                                transition: 'linear 0.6s',
                                color: 'primary.main',
                                '&:hover': {
                                    backgroundColor: 'primary.main',
                                    color: '#fff',
                                    // boxShadow: '0px 0px 8px 3px rgba(0,0,0,0.5)',
                                },
                                padding: 10,
                                alignItems: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                color: '#005696',
                                letterSpacing: 1,
                                cursor: 'pointer',
                            }}>
                                View Your Grievance Status
                            </Paper>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <Footer />
        </div>
    )
}